import React from 'react'
import { ReactTypeformEmbed } from 'react-typeform-embed'
import { useSlack } from '../components/hooks'
import { BB_TRACK_JOURNEY_TYPEFORM_URL } from '../utils/constants'

const RegisterForm: React.FC<{}> = () => {
  useSlack('BBMO Track Form')
  return <ReactTypeformEmbed url={BB_TRACK_JOURNEY_TYPEFORM_URL} />
}

export default RegisterForm
